import * as yup from 'yup';

import { DatesDropdownFields } from './DatesDropdown.types';

export const schema: yup.SchemaOf<DatesDropdownFields> = yup.object({
    dateFrom: yup.date().nullable(),
    dateTo: yup.date().nullable(),
});
